const camelcaseKeysDeep = require('camelcase-keys-deep');

export class Symptom {
  key: string;
  name: string;
  group: string;
  description: string;
  appliesTo: string;

  constructor(data: any) {
    data = camelcaseKeysDeep(data);

    this.key = data.key;
    this.name = data.name;
    this.group = data.group;
    this.description = data.description;
    this.appliesTo = 'all'; // under18, over18, all, under12, male, female
  }
}



// WEBPACK FOOTER //
// ./src/app/symptoms/symptom.ts